module.exports = __webpack_public_path__ + "static/media/bitcoin-studio-black.3c4529d3.svg";